module.exports = __webpack_public_path__ + "media/images/account-white-d288296d6a6a0a52a55f6f0fcab50169.svg";